(function () {
  var root = document.querySelector('[data-tt-cshop]');
  if (!root) return;

  var ADDED_MS = 1800;

  function parseSectionInnerHTML(html, selector) {
    if (!html) return '';
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var source = doc.querySelector(selector || '.shopify-section');
    return source ? source.innerHTML : '';
  }

  function updateCartSections(sections) {
    if (!sections) return;

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      bubble.innerHTML = parseSectionInnerHTML(sections['cart-icon-bubble']);
    }

    var drawerInner = document.querySelector('#CartDrawer');
    if (drawerInner && sections['cart-drawer']) {
      drawerInner.innerHTML = parseSectionInnerHTML(sections['cart-drawer'], '#CartDrawer');
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.querySelector('.drawer__inner')) {
        drawer.querySelector('.drawer__inner').classList.remove('is-empty');
      }
    }
  }

  function setButtonState(btn, state, label) {
    if (!btn) return;
    btn.classList.toggle('is-loading', state === 'loading');
    btn.classList.toggle('is-added', state === 'added');
    btn.disabled = state === 'loading' || state === 'added';
    if (label) btn.textContent = label;
  }

  root.addEventListener('click', function (evt) {
    var tab = evt.target.closest('[data-tt-cshop-tab]');
    if (tab) {
      var index = tab.getAttribute('data-collection-index');
      Array.prototype.slice.call(root.querySelectorAll('[data-tt-cshop-tab]')).forEach(function (el) {
        var active = el.getAttribute('data-collection-index') === index;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      Array.prototype.slice.call(root.querySelectorAll('[data-tt-cshop-panel]')).forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-collection-index') !== index;
      });
      return;
    }

    var cta = evt.target.closest('[data-tt-cshop-atc]');
    if (!cta) return;

    var card = cta.closest('[data-tt-cshop-card]');
    if (!card) return;

    var variantId = parseInt(card.getAttribute('data-variant-id'), 10);
    if (!variantId || cta.disabled) return;

    var defaultLabel = cta.getAttribute('data-default-label') || 'Add to Cart';
    setButtonState(cta, 'loading', defaultLabel);

    var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var body = {
      items: [{ id: variantId, quantity: 1 }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    };

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          setButtonState(cta, 'idle', defaultLabel);
          return;
        }

        updateCartSections(result.data.sections);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'tt-campaign-shop',
            productVariantId: variantId,
            cartData: result.data
          });
        }

        setButtonState(cta, 'added', 'Added');
        window.setTimeout(function () {
          setButtonState(cta, 'idle', defaultLabel);
        }, ADDED_MS);
      })
      .catch(function () {
        setButtonState(cta, 'idle', defaultLabel);
      });
  });
})();
